export const VIDEO_TYPES = {
  RESTAURANT: "RESTAURANT",
  PRODUCT: "PRODUCT",
};
